import { translate, useDynamicData } from '@avensia/excite';
import { authenticateIfNeeded } from '@avensia/excite-commercetools/authentication';
import { ButtonLink } from 'webapp/components/button/button';
import { TestIdProps } from '@avensia/test-automation';
import { Theme } from 'webapp/theme';
import { UserIcon } from 'webapp/components/icons';
import * as React from 'react';
import { addNavigationEventToDataLayer } from 'webapp/tracking/events/main-navigation';
import { NnTestIdProps } from 'webapp/shared/test-ids';

export function MyPagesButton() {
  const myPagesStartPageUrl = useDynamicData<NordicNest.Api.WellknownPagesApiModel>()[0]?.myPagesStartPageUrl;
  const isLoggedIn = useDynamicData<NordicNest.Api.CustomerApiModel>()[0]?.isLoggedIn;

  const onClick = () => {
    addNavigationEventToDataLayer({ to: myPagesStartPageUrl, menu_type: 'header', menu_category: 'my_pages' });
    authenticateIfNeeded();
  };

  return (
    <ButtonLink
      as={Theme.Transparent}
      disableRippleEffect
      square
      onClick={onClick}
      to={(isLoggedIn && myPagesStartPageUrl) || ''}
      aria-label={translate(t => t.header.myPages)}
      {...NnTestIdProps.MyPagesButton}
    >
      <UserIcon {...TestIdProps.MyPagesLink} />
    </ButtonLink>
  );
}
